import React from 'react'

const FormFieldErrorMessage: React.FC<any> = ({ children }) => {
  return <div className="text-warn-600 text-semibold text-sm">{children}</div>
}

export default FormFieldErrorMessage
